module.exports = __webpack_public_path__ + "static/img/042统战H5页面1.ae58f98.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/042统战H5页面1.jpg
// module id = ZYd2
// module chunks = 0